import React from 'react';
import { Route, Switch } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";

import "../style/nsoft-theme-desktop.scss";

import { getBaseRouterPath } from "../utils/config";
import PrematchLayout from "./prematch-layout";
import LiveLayout from "./live-layout";
import Error404 from "./error404";

import { prematchInitialize } from "../../bets/store/actions/prematch";
import { liveInitialize } from "../../bets/store/actions/live";

const EntryPoint = (props) => {
  const basePath = getBaseRouterPath();
  const { prematchInitialize, liveInitialize } = props;

  React.useEffect(() => {
    document.body.classList.add("nsoft-bets");
    prematchInitialize();
    liveInitialize();
    if (typeof window.config.nsoftTheme !== "undefined" && window.config.nsoftTheme) {
      document.body.classList.add(`nsoft-${window.config.nsoftTheme.toString().toLowerCase()}`);
    }

    return () => {
      document.body.classList.remove("nsoft-bets");
      if (typeof window.config.nsoftTheme !== "undefined" && window.config.nsoftTheme) {
        document.body.classList.remove(`nsoft-${window.config.nsoftTheme.toString().toLowerCase()}`);
      }
    };
  }, []); // eslint-disable-line

  return (
    <Route>
      <Switch>
        <Route path={`${basePath}/prematch`} component={PrematchLayout} />
        <Route path={`${basePath}/live`} component={LiveLayout} />
        <Route component={Error404} />
      </Switch>
    </Route>
  );
}

const mapStateToProps = state => ({
  auth: state.auth
});

const actionCreators = {
  prematchInitialize,
  liveInitialize
};

export default withTranslation()(connect(mapStateToProps, actionCreators)(EntryPoint));